import request from '@/libs/http/index'

// 查询字典数据（精简)列表
export const getSimpleDictDataList = () => {
  return request.get({ url: '/system/dict-data/simple-list' })
}
// 获得地区树
export const getAreaTree = async () => {
  return await request.get({ url: '/system/area/tree' })
}
// 获取隐私协议
export const getPrivacyDetail = async params => {
  return await request.get({ url: '/clinic/sys-agreement/get', params })
}
